





































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import CustomSelectBox from "@/components/CustomSelectBox.vue";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

interface SelectOption {
  label: string;
  value: string;
  selected?: boolean;
}

@Component({
  components: { CustomSelectBox },
})
export default class BulkUpload extends Vue {
  @Provide("$api") $api: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private currentJobId = this.jobId;
  private file: any = null;
  private fileName = "";

  private jobName = "";
  private metadata: any = {};
  private requireSupportOrNotif = false;

  private allTags: SelectOption[] = [];
  private tagsLimit = 5;
  private tagsSelectKey = 0;

  private errorMessages: string[] = [];
  private errorMessageTop = "";

  mounted() {
    if (this.currentJobId) this.getJobDetails();
  }

  @Watch("errorMessages")
  @Watch("errorMessageTop")
  focusErrorAlert() {
    if (this.errorMessages.length !== 0 || this.errorMessageTop !== "") {
      (this.$refs.uploadHeader as any).scrollIntoView();
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (
      error.response &&
      error.response.data &&
      error.response.data.details &&
      error.response.data.details.length > 0
    ) {
      this.$store.commit("recordError", "");
      this.errorMessages = error.response.data.details.map((e) => {
        if (_.has(errorsUtil.specialErrors, e.code))
          return errorsUtil.specialErrors[e.code];
        else return e.message;
      });
    } else if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  getJobDetails() {
    this.$store.commit("startLoading");
    this.$api
      .get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}`
      )
      .then((response) => {
        const jobDetails = response.data;
        this.jobName = jobDetails.metadata.jobName;
        const selectedTags = jobDetails.tags || [];
        this.metadata = jobDetails.metadata;
        this.allTags = selectedTags.map((t) => {
          return {
            label: t,
            value: t,
            selected: true,
          };
        });
        this.fileName = jobDetails.metadata.fileName;
        this.requireSupportOrNotif =
          this.$store.state.herculeRole === "ClassificationInternalExpert"
            ? jobDetails.metadata.notify == "true"
            : jobDetails.metadata.support == "true";
        this.$store.commit("stopLoading");
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private onTagInput(e: any) {
    const searchQuery: string = e.detail.inputValue.trim();
    const isAlreadyPresent =
      this.findSelectedTags().findIndex((t) => t.value === searchQuery) >= 0;
    if (searchQuery === "" || isAlreadyPresent) return;
    const addTagOption: SelectOption = {
      label: `Add the tag: ${searchQuery}`,
      value: searchQuery,
      selected: false,
    };
    this.allTags = [
      addTagOption,
      ...this.allTags.filter((t) => !t.label.startsWith("Add the tag:")),
    ];
  }

  private onTagSelected(e: any) {
    const selectedOptionLabel: string = e.detail.item.label;
    const selectedOptionValue = e.detail.item.value;
    this.allTags = [
      ...this.allTags.filter((t) => !t.label.startsWith("Add the tag:")),
      {
        label: selectedOptionValue,
        value: selectedOptionValue,
        selected: true,
      },
    ];
    this.tagsSelectKey = this.tagsSelectKey + 1;
  }

  private onTagDeselected(e: any) {
    const selectedOption = e.detail.item.value;
    this.allTags = this.allTags.filter((t) => t.value !== selectedOption);
    this.tagsSelectKey = this.tagsSelectKey + 1;
  }

  private findSelectedTags() {
    return this.allTags.filter((t) => t.selected);
  }

  private fileChosen(e) {
    this.file = e.detail.files[0];
    this.fileName = this.file.name;
  }

  private findFileType(file: any) {
    if (file && file.type) {
      if (file.type === "text/tab-separated-values") {
        return "tsv";
      }
      if (file.type === "text/csv") {
        return "csv";
      }
    }
    return file && file.name && file.name.slice(-4).toLowerCase() === ".tsv"
      ? "tsv"
      : "csv";
  }

  private removeUploadedFile() {
    if (!(this.metadata.isQuestionnaireDone == "true")) {
      this.file = null;
      this.fileName = "";
    }
  }

  private isSaveDisabled() {
    return (
      this.jobName.trim() === "" ||
      !this.fileName ||
      this.fileName === "" ||
      this.allTags.length > this.tagsLimit ||
      this.$store.state.loading
    );
  }

  async nextStep() {
    this.$store.commit("startLoading");
    try {
      await this.createOrUpdateJob();
      if (this.file) {
        const fileType = this.findFileType(this.file);
        const formData = new FormData();
        formData.append("file", this.file);
        const uploadResponse = await this.$api.put(
          `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}/upload`,
          formData,
          {
            params: { fileType },
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.$store.commit("stopLoading");
      }
      const query = Object.assign({}, this.$route.query);
      query.jobId = this.currentJobId;
      this.$router.push({ query });
      this.$emit("step-done");
    } catch (error) {
      this.$store.commit("stopLoading");
      this.displayError(error);
    }
  }

  async createOrUpdateJob() {
    const isSupportRequired =
      this.$store.getters.featureLevel("item-classification") === "full" &&
      this.$store.state.herculeRole === "ClassificationAdmin"
        ? this.requireSupportOrNotif
        : true;
    const isNotificationRequired =
      (this.$store.getters.featureLevel("item-classification") === "full" &&
        this.$store.state.herculeRole === "ClassificationAdmin") ||
      this.$store.state.herculeRole === "ClassificationInternalExpert"
        ? this.requireSupportOrNotif
        : true;

    if (this.currentJobId) {
      const metadataUpdated = Object.assign(this.metadata, {
        support: isSupportRequired ? "true" : "false",
        notify: isNotificationRequired ? "true" : "false",
        isQuestionnaireDone:
          this.metadata.isQuestionnaireDone == "true" ? "true" : "false",
      });
      await this.$api.put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}`,
        {
          jobName: this.jobName,
          tags: this.allTags.map((t) => t.value),
          metadata: metadataUpdated,
        }
      );
    } else {
      const newJobResponse = await this.$api.post(
        `item-classification-api/v1/jobs/${this.companyId}`,
        {
          categories: [],
          jobName: this.jobName,
          tags: this.allTags.map((t) => t.value),
          metadata: {
            support: isSupportRequired ? "true" : "false",
            notify: isNotificationRequired ? "true" : "false",
            isQuestionnaireDone: "false",
          },
        }
      );
      this.currentJobId = newJobResponse.data["jobId"];
      (this.$parent as any).updateJobId(this.currentJobId);
    }
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }
}
